import config from '../config/index';
import { request } from './api';

/**
 * 红包拦截
 */
export default {
  /**
   * 活动报名接口
   * http://doc.phonebus.corpautohome.com/project/302/interface/api/62139
   * https://cloud-dealercloud-arvr.xapi.autohome.com.cn
   */
  redPacketSignup(appId, orderData) {
    const domain = config.dealerCloudArVr;
    let url = `${domain}/activity/redPacket/signup?appId=${appId}`;
    if (process.env.NODE_ENV === 'development') {
      url = `${config.dealerCloud}/apigateway/api/post?__name=dealerArvr.activity.redPacket.signup&appId=${appId}`;
    }
    return request({
      type: 'post',
      data: JSON.stringify(orderData),
      url,
      crossDomain: true,
      xhrFields: { withCredentials: true },
      dataType: 'json',
      contentType: 'application/json;charset=UTF-8',
    });
  },
  /**
   * 红包领取接口
   * http://doc.phonebus.corpautohome.com/project/302/interface/api/61293
   */
  redPacketReceive(appId, orderData) {
    const domain = config.dealerCloudArVr;
    let url = `${domain}/activity/redPacket/receive?appId=${appId}`;
    if (process.env.NODE_ENV === 'development') {
      url = `${config.dealerCloud}/apigateway/api/post?__name=dealerArvr.activity.redPacket.receive&appId=${appId}`;
    }
    return request({
      type: 'post',
      data: JSON.stringify(orderData),
      url,
      crossDomain: true,
      xhrFields: { withCredentials: true },
      dataType: 'json',
      contentType: 'application/json;charset=UTF-8',
    });
  },
};
